"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MENU_NAVIGATION = 'MENU_NAVIGATION';
//# sourceMappingURL=Types.js.map